import React, { useCallback, useEffect } from 'react';
import _ from 'lodash';

import './Cards.css';
import { useOrgIdSelect } from 'components/Select/useOrgIdSelect';
import { privileges } from 'utils/types';


const WizardStepOrganization = ({ unusedAssetInfo, setAssetInfo, setIsValid }) => {

  const _onChange = useCallback((currentOrganization) => {
    setAssetInfo(oldAssetInfo => {
      if (!_.isEqual(oldAssetInfo.currentOrganization, currentOrganization)) {
        return { ...oldAssetInfo, currentOrganization };
      }
      return oldAssetInfo;
    });
  }, [setAssetInfo]);

  const { renderOrgIdSelect, currentOrg } = useOrgIdSelect({
    onChange: _onChange,
    neededPrivilege: privileges.AssetManagement
  });

  useEffect(() => {
    _onChange(currentOrg);
    setIsValid(!_.isEmpty(currentOrg));
  }, [_onChange, currentOrg, setIsValid]);

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      { renderOrgIdSelect() }
    </div>
  );
};

export default WizardStepOrganization;
